// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bv-2";
export var aiChatCartContainerExit = "_bv-4";
export var aiChatContainerLarge = "_bv-0";
export var aiChatContainerSmall = "_bv-1";
export var aiChatIcon = "_bv-6";
export var slideInFromRight = "_bv-3";
export var slideOutToRight = "_bv-5";